<template>
  <div class="questionnaire-copy">
    <div class="questionnaire-copy__title">
      {{ title }}
    </div>
    <div
      class="questionnaire-copy__field"
      @click="copyText"
    >
      <p
        v-if="!loading"
        ref="input"
        class="questionnaire-copy__text"
      >
        <span>{{ text }}</span>
      </p>
      <p
        v-else
        class="questionnaire-copy__text ajax__line -round-"
        :style="{height: '26px', width: '160px'}"
      />
      <div class="questionnaire-copy__icon-wrap">
        <Icon
          v-if="!loading"
          class="questionnaire-copy__icon"
          icon="ui-copy"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {},
    text: {},
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    copyText() {
      navigator.clipboard
        .writeText(this.text)
        .then(() => {
          this.$store.dispatch(
            'ajax/addMessage',
            { message: 'Код скопирован', type: 'success' },
            { root: true }
          );
        })
        .catch(() => {
          console.warn('Не удалось скопировать код');
        });
    }
  }
};
</script>
